import { render, staticRenderFns } from "./RptCommodityAnalyse.vue?vue&type=template&id=c1278890&"
import script from "./RptCommodityAnalyse.vue?vue&type=script&lang=ts&"
export * from "./RptCommodityAnalyse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports